export default __webpack_public_path__ + "static/media/food2.df1324f0.jpg";